"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vueFieldLabelMixin = exports.vueComponentMixin = exports.$injectDataField = exports.$chrootContext = exports.$formContext = void 0;
const tslib_1 = require("tslib");
const mergeClassName_1 = tslib_1.__importDefault(require("../utils/mergeClassName"));
// 用于 vue 的 inject 和 provide
// <data-form> 组件会 provide 这些东西。这些都是函数
exports.$formContext = 'data-form:formContext'; // () => DataFormContext
exports.$chrootContext = 'data-form:chrootContext'; // () => ChrootContext
exports.$injectDataField = 'data-form:dataField'; // Vue
/**
 * 定义了输入框组件可收到的 props
 */
const vueComponentProps = {
    /** 当前字段的 DataSchema @type {DataSchema} */
    schema: { type: Object },
    /** 不要使用 schema.ui，那个可能为空！用这个 @type {DataUIConfig} */
    ui: { type: Object },
    /** 这个是 ui.settings 融合了默认值的结果。如果这个输入框组件没提供 settingsSchema，请无视 */
    uiSettings: { type: Object },
    /** 是否只读，可能是 boolean 或者 undefined */
    readonly: { required: false },
    /** 是否展示收起的样式（仅在 collapsible 配置为 true 时可能有值） */
    collapsed: { required: false },
    /** 当前值 */
    value: { required: true },
    /** 由挂载器注入的样式（例如数据有错误之类的） */
    className: { type: String, required: false },
    /**  (可忽略) 由挂载器注入的 input id，因为挂载器可能有 <label> 需要和 <input id="xxx"> 绑定 */
    inputId: { type: String, required: false },
    /** （可忽略）挂载器展示的标签文字，适用于 配置了 noLabel 的输入框组件（例如勾选框，要把标签挪到组件里面展示） */
    labelText: { type: String, required: false },
};
/**
 * 用于编辑框组件的基本 mixin，定义了输入框组件可收到的 props，以及有用的一些别名
 *
 * 注意：组件内需要提交修改，可通过
 * - `this.editValue = 新值`
 * - 在组件内部使用 `v-model="editValue"` 也ok
 */
exports.vueComponentMixin = {
    props: vueComponentProps,
    inject: {
        container: { from: exports.$injectDataField, default: null }
    },
    computed: {
        // editValue 用于 v-model
        editValue: {
            get() {
                return this.$props.value;
            },
            set(val) {
                this.$emit("change", val);
            }
        },
        // 只是别名而已
        settings() { return this.uiSettings || {}; },
        props() { return this.$props; },
        context() { var _a; return (_a = this.container) === null || _a === void 0 ? void 0 : _a.formContext; },
    }
};
/** 用于渲染字段输入框标题 的组件 的 props */
const labelComponentProps = {
    htmlFor: { type: String, required: false },
    text: { type: String, required: false },
    schema: { type: Object },
    collapsible: { type: Boolean, default: false },
    collapsed: { type: Boolean, default: false }, // 展开/收起的状态。Label组件内通过 $emit('update:collapsed', val) 更新
};
/** 用于渲染字段输入框标题 的组件 的 mixin */
exports.vueFieldLabelMixin = {
    props: labelComponentProps,
    computed: {
        collapseStateClass() {
            const { collapsed, collapsible } = this;
            const collapseStateClass = collapsible && (collapsed ? 'is-collapsed' : 'is-expanded');
            return collapseStateClass;
        },
        className() {
            const { collapseStateClass, collapsible } = this;
            return (0, mergeClassName_1.default)('ds-fieldLabel', collapsible && 'is-collapsible', collapseStateClass);
        }
    },
    methods: {
        onClick() {
            //@ts-ignore
            this.$emit('update:collapsed', !this.collapsed);
        }
    }
};
//# sourceMappingURL=definitions.js.map